import { render, staticRenderFns } from "./AsideMobage.vue?vue&type=template&id=5b7140d2&scoped=true&"
import script from "./AsideMobage.vue?vue&type=script&lang=js&"
export * from "./AsideMobage.vue?vue&type=script&lang=js&"
import style0 from "./AsideMobage.vue?vue&type=style&index=0&id=5b7140d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7140d2",
  null
  
)

component.options.__file = "AsideMobage.vue"
export default component.exports